var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.Is,{ref:"listcom",tag:"component",attrs:{"config":_vm.config,"parent":_vm.parent,"panel":_vm.panel},on:{"panel-change":_vm.handlePanelChange,"config-change":_vm.handleConfigChange,"meta-change":_vm.handleMetaChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }